import { render, staticRenderFns } from "./aside-section.component.vue?vue&type=template&id=4c30d186&scoped=true"
import script from "./aside-section.component.vue?vue&type=script&lang=ts"
export * from "./aside-section.component.vue?vue&type=script&lang=ts"
import style0 from "./aside-section.component.vue?vue&type=style&index=0&id=4c30d186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30d186",
  null
  
)

export default component.exports